import _ from 'lodash';
import api from '../index';

export const fetchAll = async (url) => {
  const limit = 1000;

  const firstResponse = await api.get(`${url}?limit=${limit}&offset=0`);
  const totalPages = Math.ceil(firstResponse.data.totalElements / limit);
  let allData = [...firstResponse.data.content];

  if (totalPages <= 1) {
    return allData;
  }

  const requests = [];
  for (let i = 1; i < totalPages; i++) {
    requests.push(api.get(`${url}?limit=${limit}&offset=${i}`));
  }

  const responses = await Promise.all(requests);
  responses.forEach((res) => {
    allData.push(...res.data.content);
  });

  return _.uniqBy(allData, 'id');
};
